import { API_BASE, getApiHeaders } from './apiClient';

export async function getMicrosoftAuthUrl(incidentId: string): Promise<string> {
  const res = await fetch(`${API_BASE}/cima/microsoft/auth?incidentId=${incidentId}`, { headers: getApiHeaders() });
  const data = await res.json();
  return data.authUrl;
}

export async function getMicrosoftStatus(): Promise<{ authenticated: boolean; email: string }> {
  const res = await fetch(`${API_BASE}/cima/microsoft/status`, { headers: getApiHeaders() });
  return res.json();
}

export async function createTeamsMeeting(data: {
  title: string; scheduledAt: string; durationMinutes: number;
  incidentId: string; invitees: { name: string; email: string }[];
}): Promise<{
  meetingId: number;
  joinUrl: string;
  teamsMeetingId: string;
  chatId: string;
  /** Pre-filled SitRep+IAP XLSX (base64) — attached to the Teams invite
   *  AND returned here so the scheduling UI can trigger a local download. */
  iapXlsx?: string;
  iapXlsxFilename?: string;
  iapActionCount?: number;
}> {
  const res = await fetch(`${API_BASE}/cima/microsoft/meeting`, {
    method: 'POST', headers: getApiHeaders(),
    body: JSON.stringify(data),
  });
  const result = await res.json();
  if (!res.ok) throw new Error(result.error || 'Failed to create meeting');
  return result;
}

export async function pullMeetingChat(meetingId: number): Promise<{ notes: string | null; source?: string; status?: string }> {
  const res = await fetch(`${API_BASE}/cima/microsoft/meeting/${meetingId}/pull-notes`, {
    method: 'POST', headers: getApiHeaders(),
  });
  const result = await res.json();
  if (res.status === 202) return { notes: null, status: 'processing' };
  if (!res.ok) throw new Error(result.error || 'Failed to pull notes');
  return result;
}
